import React, { useRef, useState } from 'react';
import { Card, Modal, Space, Image, Carousel, Button, Segmented } from 'antd';
import './styles.css';

const defaultLang = "O'zbek";
const { Meta } = Card;
export const MapModal = ({ isModalOpen, setModalVisibility, place }) => {
  const slider = useRef();
  const [lang, setLang] = useState(defaultLang);

  return (
    <Modal
      width={1200}
      centered
      title={null}
      destroyOnClose
      open={isModalOpen}
      onCancel={() => setModalVisibility(false)}
      footer={null}
    >
      <Space align='start'>
        {place?.src.length > 0 && (
          <div className='carousel_container'>
            <Carousel ref={slider} dots={false}>
              {place?.src.map((url) => (
                <div key={url}>
                  <Image
                    preview={false}
                    key={url}
                    width={500}
                    src={require(`../../assets/areas/${url}`)}
                  />
                </div>
              ))}
            </Carousel>
            {place?.src.length > 1 && (
              <div className='carousel_dotsBlock'>
                <Space>
                  <Button onClick={() => slider.current?.prev()} shape='circle'>
                    <img
                      className='arrowCarousel'
                      src={require('../../assets/271218.png')}
                      alt='left'
                    />
                  </Button>
                  <Button onClick={() => slider.current?.next()} shape='circle'>
                    <img
                      className='arrowCarousel'
                      src={require('../../assets/right.png')}
                      alt='right'
                    />
                  </Button>
                </Space>
              </div>
            )}
          </div>
        )}

        <Card
          bordered={false}
          title={lang === defaultLang ? place?.uzLang.title : place?.engLang.title}
          extra={
            <Segmented defaultValue={lang} onChange={setLang} options={["O'zbek", 'English']} />
          }
        >
          <Meta
            description={
              lang === defaultLang ? place?.uzLang.description : place?.engLang.description
            }
          />
        </Card>
      </Space>
    </Modal>
  );
};
